module.exports = __webpack_public_path__ + "img/resepsjonist_432px.29c7aa94.jpg";